(function ($, dell) {
    dell.Components = dell.Components || {};
    dell.Components.DetectProductRppsRvps = dell.Components.DetectProductRppsRvps || {};

    (function () {

        var noSupportAssist = (progressBar) => {
            setTimeout(function () {
                progressBar.css('width', '66%');
                setTimeout(function () {
                    $('.slick-next').css('visibility', 'visible');
                    $('.js-detected-product').removeClass('d-none');
                    $('.js-unable-to-detect').removeClass('d-none').addClass('d-flex');
                    $('.js-detected-product').removeClass('d-none').addClass('d-flex');
                    $('.js-additional-product').removeClass('d-none').addClass('d-block');
                    $('.js-progress-container').hide();
                    $('.js-progress-label').hide();
                }, 500);
            }, 2000);
        };

        var detectingPc = (progressBar) => {
            setTimeout(function () {
                progressBar.css('width', '33%');
                noSupportAssist(progressBar);
            }, 2000);
        };

        this.Init = () => {
            $('#supportAssistWidget').on('init',
                function () {
                    $('#supportAssistWidget').fadeIn(1000);
                }).slick({
                    lazyLoad: 'ondemand',
                    speed: 300,
                    slidesToShow: 2,
                    variableWidth: true,
                    infinite: false,
                    nextArrow: `<button type="button" class="slick-next" onclick="Dell.Components.DetectProduct.onDetectProductNextClick()"><svg class="dti dti-lg"><svg viewBox="0 0 32 32"><path d="M9.96 1.922l-1.331 1.333 12.745 12.745-12.745 12.745 1.331 1.333 14.078-14.078z"></path></svg></svg></button>`,
                    prevArrow: `<button type="button" class="slick-prev"><svg class="dti dti-lg"><svg viewBox="0 0 32 32"><path d="M23.371 3.255l-1.331-1.333-14.078 14.078 14.078 14.078 1.331-1.333-12.745-12.745z"></path></svg></svg></button>`
                });
            let progressBar = $('.progress-bar');
            progressBar.css('width', '0%');
            $('.slick-next').css('visibility', 'hidden');
            $('.detect-pc-widget').css('display', 'flex');
            detectingPc(progressBar);
            this.getDetectPcRvpsRpps();
        };

        this.reInit = () => {
            $('#supportAssistWidget').slick('unslick').children('.slide').nextAll().remove();
            this.Init();
        };

        this.getDetectPcRvpsRpps = () => {

            let componentLoader = Dell.ComponentLoader;
            var detectProduct = Dell.Components.DetectProduct;

            Dell.ComponentLoader.appNames["detect-product"] = Dell.ComponentLoader.appNames["detectproduct-rvps-rpps"];
            Dell.ComponentLoader.appNames["rvps"] = Dell.ComponentLoader.appNames["detectproduct-rvps-rpps"];
            Dell.ComponentLoader.appNames["rpps"] = Dell.ComponentLoader.appNames["detectproduct-rvps-rpps"];

            // call detect product
            if (componentLoader.isEnterpriseUser === false && detectProduct.enableDetectMyProduct && !window.detectPcRvpsMobile) {
                detectProduct.callSa();
            } else {
                if ($('#divAutoDetectPc').length !== 0) {
                    $('#supportAssistWidget').slick('slickRemove', 0);
                }
                let detectResponse = {
                    serviceTag: '',
                    supportAssistInstalled: false
                };
                detectProduct.detectProductPromise.resolve(detectResponse);
            }

            // call Rvps and RPPS
            var rvps = Dell.Components.RecentlyViewedProducts;
            var rpps = Dell.Components.RecentlyPurchasedProducts;
            var rvpsCount = 0;
            var hasRVPS = false;
            var hasRPPS = false;
            var thisPC = false;
            let rvpsurlPath = rvps.Url();
            let rvpsurl = `${rvpsurlPath.baseUrl}/${rvpsurlPath.getRVPS}`;
            let rppsurlPath = rpps.Url();
            let rppsurl = `${rppsurlPath.baseUrl}/${rppsurlPath.getPurchasedproducts}`;
            var thisPCserviceTag = '';

            $.when(detectProduct.detectProductPromise.promise(),
                rvps.makeAjaxCall(rvpsurl, "GET"),
                rpps.makeAjaxCall(rppsurl, "GET"))
                .done(function (detectProductResponse, rvpsResponse, rppsResponse) {
                    let rvpsHtml = '';
                    let rppsHtml = '';
                    thisPC = detectProductResponse.serviceTag !== '';
                    thisPCserviceTag = detectProductResponse.serviceTag;
                    if (rppsResponse !== undefined && rppsResponse !== null && rppsResponse[0] !== null &&
                        rppsResponse[0].Result !== undefined &&
                        rppsResponse[0].Result.Assets !== undefined &&
                        rppsResponse[0].Result.Assets.length > 0) {

                        if (detectProductResponse.serviceTag !== '') {
                            rppsResponse[0].Result.Assets =
                                dell.Components.DetectProductRppsRvps.RemoveDetectTagFromRPPS(
                                    rppsResponse[0].Result.Assets,
                                    detectProductResponse.serviceTag);
                        }
                        rppsHtml = rpps.createRppsHtml(rppsResponse[0]);
                        hasRPPS = rppsResponse[0].Result.Assets.length > 0;

                    }
                    if (rvpsResponse !== undefined && rvpsResponse !== null && rvpsResponse[0] !== null &&
                        rvpsResponse[0].RecentlyViewedList !== null &&
                        rvpsResponse[0].RecentlyViewedList.length > 0) {

                        if (detectProductResponse.serviceTag !== '') {
                            rvpsResponse[0].RecentlyViewedList =
                                dell.Components.DetectProductRppsRvps.RemoveDetectTagFromRVPS(
                                    rvpsResponse[0].RecentlyViewedList,
                                    detectProductResponse.serviceTag);
                        }
                        if (rppsHtml !== '') {
                            rvpsResponse[0].RecentlyViewedList =
                                dell.Components.DetectProductRppsRvps.FilterRPVS(rvpsResponse[0].RecentlyViewedList,
                                    rppsResponse[0].Result.Assets);
                        }
                        rvpsHtml = rvps.createRvpsHtml(rvpsResponse[0]);
                        rvpsCount = rvpsResponse[0].RecentlyViewedList.length;
                        hasRVPS = rvpsResponse[0].RecentlyViewedList.length > 0;
                    }
                    if (rppsHtml !== '' || rvpsHtml !== '') {
                        if (rppsHtml !== '') {
                            rvps.renderView(rppsHtml);
                        }
                        if (rvpsHtml !== '') {
                            rvps.renderView(rvpsHtml);
                        }
                        rvps.renderView(`<div id="divemptyslidervps" class="slide"><div class="d-none js-additional-product"></div></div>`);
                    } else {
                        rvps.reInitSlick();
                    }
                }).fail(function () {
                    console.error('rvps rpps failed');
                    slickRvpsRailRemoveFunction();
                    rvps.reInitSlick();
                }).always(function () {
                    slickRvpsRailRemoveFunction();
                    rvps.checkAndHideIntegratedRvpsDiv();
                    Dell.Components.DetectProductRppsRvps.IntegratedRVPSLoaded(rvpsCount, $('#supportAssistWidget').slick("getSlick").slideCount);
                    Dell.Components.DetectProductRppsRvps.IntegratedPCRVPSPurchaseProdsLoaded(hasRVPS, hasRPPS, thisPC, thisPCserviceTag);
                });
        };

        this.slickRvpsRailRemove = () => {
            var railRvpsUi = $('.js-product-rvps-rpps-skeleton');
            var divAutoDetectPc = $('#divAutoDetectPc');
            var index = 0;
            if (divAutoDetectPc.length > 0) {
                index = 1;
            }
            for (var i = 0; i < railRvpsUi.length; i++) {
                $('#supportAssistWidget').slick('slickRemove', index);
            }
            $('.js-product-rvps-rpps-skeleton').remove();
        };

        window.removeProduct = (event) => {
            // Get total number of slides
            let slides = $('#supportAssistWidget .slide');
            let currentSlide = $('#supportAssistWidget').slick('slickCurrentSlide');

            // If slickCurrentSlide === totalSlides - 2
            // after removing, run slickPrev()
            if (currentSlide === slides.length - 2) {
                $('.slick-container').slick('slickRemove', currentSlide);
                $('#supportAssistWidget').slick('slickPrev');
            } else {
                $('.slick-container').slick('slickRemove', currentSlide);
            }
        };

        this.FilterRPVS = (recentlyViewedList, assets) => {
            let assetsServiceTags = assets.map(asset => { return asset.EsvcTag; });
            let filteredRvps = recentlyViewedList.filter(item => assetsServiceTags.indexOf(item.ServiceTag) === -1);
            return filteredRvps;
        };

        this.RemoveDetectTagFromRVPS = (list, serviceTag) => {
            let filteredList = list.filter(item => item.ServiceTag !== serviceTag);
            return filteredList;
        };

        this.RemoveDetectTagFromRPPS = (list, serviceTag) => {
            let filteredList = list.filter(item => item.EsvcTag !== serviceTag);
            return filteredList;
        };

        this.IntegratedRVPSLoaded = (rvpsCount) => {
            let callBackFuncName = "window.OnIntegratedRVPSLoaded";
            if (eval("typeof " + callBackFuncName) !== "undefined") {
                let callBackFun = eval(callBackFuncName);
                let data = {
                    "rvpsCount": rvpsCount
                };
                callBackFun.call(this, data);
            }
        };

        this.IntegratedPCRVPSPurchaseProdsLoaded = (hasAnyRVPS, hasAnyPP, isPC, serviceTag) => {
            let callBackFuncName = "window.OnPCRVPSPurchaseProdsLoaded";
            if (eval("typeof " + callBackFuncName) !== "undefined") {
                let callBackFun = eval(callBackFuncName);
                let data = {
                    "rvpsOffered": hasAnyRVPS,
                    "purchaseProdOffered": hasAnyPP,
                    "thisPCOffered": isPC,
                    "serviceTag": serviceTag
                };
                callBackFun.call(this, data);
            }
        };

        var init = this.Init;
        var slickRvpsRailRemoveFunction = this.slickRvpsRailRemove;

        $(document).ready(function () {
            init();
        });

    }).apply(dell.Components.DetectProductRppsRvps);
})(jQuery, Dell = window.Dell || {});